import React from 'react'
import { Button } from '../ui/button'
import Link from 'next/link'

function BookButton({ doctorsName }) {
    // console.log(doctorsName,'pp')
    return (
        <div className='mt-5 '>
            <Link href={`/book/book?doctor=${doctorsName}`} className="bg-primaryBlue block w-fit text-primaryWhite rounded-full border hover:bg-buttonbg hover:border-primaryWhite hover:text-primaryWhite uppercase px-8 py-3 mt-6 mb-4 relative transition-all duration-700 p-text"> BOOK AN APPOINTMENT </Link>
        </div>
    )
}

export default BookButton